import OtpInput from 'otp-input-react';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { CgSpinner } from 'react-icons/cg';
import { Button, DialogActions, Typography } from '@mui/material';
// import { useAppointmentContext } from '../contexts/appointmentcontext';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';

const RESEND_INTERVAL = 59;

function OtpTimer() {
    const { appointmentDetails: appointment } = useAppointmentDetailsContext();
    const [timing, setTiming] = useState(RESEND_INTERVAL);
    const [loading, setLoading] = useState(false);

    const generateOtp = async () => {
        try {
            const url = APIUtils.getAdminAPIEndpoint('generate-appointment-completion-otp');
            const body = {apptId: appointment.id};
            setLoading(true);
            const res = await httpClient.post(url, body).then(res => res.data);
            if (res.status === 'success') {
                setTiming(RESEND_INTERVAL);
            } else {
                Swal.fire('Something Went Wrong!', '', 'error');
            }
            setLoading(false);
        } catch (error) {
            if (error?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                setLoading(false);
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
        }
    };

    useEffect(() => {
        if (timing === 0) {
            return;
        }

        const timer = setInterval(() => {
            setTiming(prev => prev - 1);
            if (timing === 0) {
                clearInterval(timer);
            }
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, [timing]);

    const timerUI = timing !== 0 && (
        <div className='otp-timer'>
            <Typography variant="subtitle2" gutterBottom>
                Retry after {timing}&nbsp;seconds
            </Typography>
        </div>
    );

    const btnUI = () => {
        if (loading) {
            return <> Resending OTP...&nbsp;<CgSpinner size={20} className='mt-1 animate-spin' /> </>;
        }
        return 'Resend';
    };

    const verifyDisabled = timing !== 0;

    return (
        <>
            {timerUI}
            <Button variant='contained' color='primary' disabled={verifyDisabled} onClick={generateOtp}>
                {btnUI()}
            </Button>
        </>
    );
}

function OtpVerification() {
    const { appointmentDetails: appointment, setAppointmentDetails } = useAppointmentDetailsContext();
    const [otp, setOtp] = useState(false);
    const [loading, setLoading] = useState(false);

    const verifyOtp = async () => {
        try {
            const url = APIUtils.getAdminAPIEndpoint('verify-appointment-completion-otp');
            const body = {apptId: appointment.id, otp};
            setLoading(true);
            const res = await httpClient.post(url, body).then(res => res.data);
            if (res.status === 'success') {
                const message = 'COMPLETED Successfully!';
                Swal.fire('Status!', message, 'success');
                // Update Selected Appointment
                // const appt = {...appointment, status: 'COMPLETED'};
                // document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.UPDATE_SELECTED_APPOINTMENT, { detail: appt }));
                setAppointmentDetails(prev => ({...prev, status: 'COMPLETED'}));
                // Close Otp Dialog
                document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TOGGLE_OTP_DIALOG, { detail: false }));
                // Fetch appointment list
                // document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.FETCH_APPOINTMENTS));
            } else {
                Swal.fire('Something Went Wrong!', '', 'error');
            }
            setLoading(false);
        } catch (error) {
            if (error?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                setLoading(false);
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
        }
    };

    const otpUI = <OtpInput
        value={otp}
        onChange={setOtp}
        OTPLength={6}
        otpType='number'
        disabled={false}
        autoFocus
        className='otp-input'
    />;

    const btnUI = () => {
        if (loading) {
            return <> Verifying OTP...&nbsp;<CgSpinner size={20} className='mt-1 animate-spin' /> </>;
        }
        return 'Verify';
    };

    const btnDisabled = !otp || otp && otp.length < 6 || loading;

    return (
        <div className='otp-verification-container'>
            {otpUI}
            <DialogActions>
                <OtpTimer appointment={appointment} />
                <Button variant='contained' color='primary' disabled={btnDisabled} onClick={verifyOtp}>
                    {btnUI()}
                </Button>
            </DialogActions>
        </div>
    );
}

export default OtpVerification;